<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Загрузка Разрешение на отгрузку
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <input
        id="get-file-dialog"
        type="file"
        @change="handleFiles"
      >
      <v-spacer />
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            small
            class="my-0"
            :loading="fileLoading"
            v-on="on"
            @click="openFileOption"
          >
            Выбрать файл
          </v-btn>
        </template>
        <span>При импорте файла в поставках<span class="red--text">*</span> будет установлено значение метки <b>Груз можно отгружать?</b>
          <br>в значение указанное в файле (<b>Да</b> или <b>Нет</b>).
          <br>
          <br><span class="red--text">*</span>Поставка соответствует условиям:
          <br><span class="ml-2">&#8729; наименование Клиента в Поставке - есть в загружаемом файле</span>
          <br><span class="ml-2">&#8729; установлена Дата Доставки/Факт</span>
          <br><span class="ml-2">&#8729; Последнее звено с местом прибытия Наш склад</span>
          <br><span class="ml-2">&#8729; Нет Отгрузки с полной выдачей товара</span>
        </span>
      </v-tooltip>
    </v-card-text>
  </v-card>
</template>

<script>
import { importShippingReleaseApprovement } from "../../../backend/importApi.js";

export default {
  data() {
    return {
      fileLoading: false,
    };
  },
  methods: {
    openFileOption() {
      var inputElement = document.getElementById("get-file-dialog");
      inputElement.click();
    },
    handleFiles(ev) {
      this.fileLoading = true;
      const file = ev.target.files[0];

      const reader = new FileReader();

      reader.onload = (e) => {
        var arrayBuffer = e.target.result;
        var array = Array.from(new Uint8Array(arrayBuffer));

        this.import({ originName: file.name, data: array, type: 1 });
      };
      if (file) {
        reader.readAsArrayBuffer(file);
      } else {
        this.fileLoading = false;
      }
    },
    async import(fileInfo) {
      await importShippingReleaseApprovement(fileInfo);
      this.$router.push({ name: "shippings" });
      this.fileLoading = false;
    },
  },
};
</script>

<style>
#file-dialog {
  display: none;
}
</style>
